import React from "react";
import Card from "react-bootstrap/Card";
import { Badge } from "react-bootstrap";

function ProjectCards({ imgPath, videoPath, title, description, tags = [] }) {
  return (
    <Card className="project-card-view">
      {/* Video if provided, otherwise fallback to image */}
      {videoPath ? (
        <video
          controls
          autoPlay
          muted
          loop
          playsInline
          style={{
            // width: "100%",
            minHeight: "200px",
            maxHeight: "200px",
            borderTopLeftRadius: "0.5rem",
            borderTopRightRadius: "0.5rem",
          }}
        >
          <source
            src={videoPath}
            type={videoPath.endsWith(".webm") ? "video/webm" : "video/mp4"}
          />
          Your browser does not support the video tag.
        </video>
      ) : (
        imgPath && <Card.Img
          variant="top"
          src={imgPath}
          alt="card-img"
          style={{
            minHeight: "200px",   // ↑ increase height
            maxHeight: "200px",   // ↑ limit max height
            objectFit: "cover",   // ↑ cover ensures it scales nicely
          }}
        />
      )}

      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>{description}</Card.Text>

        {/* Tags */}
        <div style={{ marginTop: "10px" }}>
          {tags.map(tag => (
            <Badge key={tag} bg="danger" style={{ marginRight: "5px" }}>
              {tag}
            </Badge>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
